import { Store, Module, ActionContext } from 'vuex'
import Ajax from '../../lib/ajax'
import ListModule from './list-module'
import ListState from './list-state'
import appconst from './../../lib/appconst';
import PageResult from '@/store/entities/page-result';
import ViewPASoShortedSku from '../entities/report-pa-so/view-pa-so-shorted-sku'
interface ViewPASoShortedSkuState extends ListState<ViewPASoShortedSku> {
   
}
class ViewPASoShortedSkuModule extends ListModule<ViewPASoShortedSkuState, any, ViewPASoShortedSku>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ViewPASoShortedSku>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<ViewPASoShortedSkuState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/VwPASoShortedSku/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<ViewPASoShortedSku>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async exportAllPASoShortedSkuToExcel(context:ActionContext<ViewPASoShortedSkuState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}export/ExportAllPASalesOrderShortedSku?keyWord=`+payload.data.keyWord+`&warehouseCode=`+payload.data.warehouseCode, "_blank");    
        },
        async exportAllPASoShortedSkuInfoToExcel(context:ActionContext<ViewPASoShortedSkuState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}export/ExportAllPASaleOrderShortedSkuInfo?productId=`+payload.data.productId+`&warehouseCode=`+payload.data.warehouseCode, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: ViewPASoShortedSkuState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ViewPASoShortedSkuState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const viewPASoShortedSkuModule = new ViewPASoShortedSkuModule();
export default viewPASoShortedSkuModule;